import { ModelBase, NeoModel, Rules, Validation } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateColumnSpecCommand extends ModelBase {

    public staticColumnSpecID: number = 0;

    public staticFileSpecID: number = 0;

    @Rules.StringLength(1000)
    @Rules.Required()
    public description: string = "";

    @Rules.Required()
    public columnNumber: number = 0;

    @Rules.StringLength(100)
    @Rules.Required()
    public fileFieldName: string = "";

    @Rules.StringLength(100)
    @Rules.Required()
    public databaseFieldName: string = "";

    @Rules.StringLength(20)
    @Rules.Required()
    public dataType: string = "";

    public allowsNullsInd: boolean = false;

    public isUniqueInd: boolean = false;

    public generatesTransactionRecordInd: boolean = false;

    public isCurrencyInd: boolean = false;

    public isCountryInd: boolean = false;

    public ignoreColumnInd: boolean = false;

    public dateFormat: string = "";

    public fileSpecColumnCount: number = 0;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.columnNumber < 1, "Column number must be greater than zero.");
        rules.failWhen(d => d.dataType === "Datetime" && (d.dateFormat === undefined || d.dateFormat === ""), "Date format must be populated for datetime types.");
        rules.failWhen(s => s.columnNumber > (s.fileSpecColumnCount + 1),"Invalid column number.");
    }
}